let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lJcFT")).then(() => parcelRequire('eKJpt'));